import { createFileRoute } from "@tanstack/react-router";
import { CertificacaoLP } from "@/components/certificacao/CertificacaoLP";
import { CERT_LP_INDEXAVEL, CERT_META } from "@/lib/certificacao/config";
import { CERT_DATA } from "@/lib/certificacao/data";
import { certOfertaLp } from "@/lib/certificacao/oferta";

const m = CERT_META.ombro;
const SITE = "https://fisioemortopedia.com.br";
const URL = `${SITE}${m.path}`;
/** Compartilhamento usa o JPG do fundo hexagonal (alguns leitores de link não renderizam WebP). */
const SHARE_IMG = CERT_DATA.ombro.heroBg?.startsWith("https://") ? CERT_DATA.ombro.heroBg : undefined;
const PRECO = certOfertaLp("ombro").aVistaValor.replace(/\D+/g, "");

export const Route = createFileRoute("/certificacao-ombro")({
  head: () => ({
    meta: [
      { title: m.seoTitle },
      { name: "description", content: m.seoDescription },
      // Variantes de teste permanecem fora do índice; LP oficial é indexável.
      ...(CERT_LP_INDEXAVEL ? [] : [{ name: "robots", content: "noindex,nofollow" }]),
      { property: "og:title", content: m.seoTitle },
      { property: "og:description", content: m.seoDescription },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      { property: "og:site_name", content: "Fisio em Ortopedia" },
      ...(SHARE_IMG ? [{ property: "og:image", content: SHARE_IMG }] : []),
      { property: "og:locale", content: "pt_BR" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: m.seoTitle },
      { name: "twitter:description", content: m.seoDescription },
      ...(SHARE_IMG ? [{ name: "twitter:image", content: SHARE_IMG }] : []),
    ],
    links: [
      { rel: "canonical", href: URL },
      ...(CERT_DATA.ombro.heroBg
        ? [{ rel: "preload", as: "image", href: CERT_DATA.ombro.heroBg, fetchPriority: "high" as const }]
        : []),
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Course",
          name: m.nome,
          description: m.seoDescription,
          url: URL,
          inLanguage: "pt-BR",
          educationalLevel: "Profissional",
          teaches: "Avaliação e tratamento do complexo do ombro",
          provider: { "@type": "Organization", name: "Fisio em Ortopedia", url: SITE },
          offers: {
            "@type": "Offer",
            price: `${PRECO}.00`,
            priceCurrency: "BRL",
            url: URL,
            availability: "https://schema.org/InStock",
          },
          hasCourseInstance: { "@type": "CourseInstance", courseMode: "online", courseWorkload: "PT60H" },
        }),
      },
    ],
  }),
  component: CertOmbroRoute,
});

function CertOmbroRoute() {
  return <CertificacaoLP slug="ombro" mode="venda" embeddedCheckout />;
}
